import { Injectable, NgModule } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, publishReplay, refCount } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteParamChangesService {

  private _routeChanges: Observable<Params>;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) { }

  watch(): Observable<Params> {
    if (!this._routeChanges) {
      this._routeChanges = this.router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        map(() => this._getParams(this.route)),
        publishReplay(1),
        refCount()
      );
    }
    return this._routeChanges;
  }

  getPath() {
    return this._getPath(this.route);
  }

  private _getParams(route: ActivatedRoute): Params {
    let params = route.snapshot.params;
    params = { ...route.snapshot.queryParams, ...params };
    if (route.children) {
      for (const r of route.children) {
        params = { ...this._getParams(r), ...params };
      }
    }
    return params;
  }
  
  private _getPath(route: ActivatedRoute): string[] {
    let path = route.snapshot.url.map(results => results.path);
    if (route.children) {
      for (const r of route.children) {
        path = [...path, ...this._getPath(r)];
      }
    }
    return path;
  }
}

@NgModule({
  imports: [RouterModule],
  providers: [RouteParamChangesService]
})
export class RouteParamsModule { }
